import { useTranslation } from 'react-i18next';
import { selectedRoadSectionsQuery } from '../../../../../core/reference/queries';
import { useAppDispatch, useAppSelector } from '../../../../../types';
import { useEffect, useState } from 'react';
import { ContentContainer, ModalTitle } from '../../../../legacy/components/ui/modals/styles';
import GenericModal from '../../../../legacy/components/ui/modals/GenericModal';
import { ReferenceModalTypes } from '../../../../../core/legacy/reducers/modals';
import { Input } from '../../../../session/list-sessions/styles';
import editRoadSections from '../../../../../core/reference/commands/EditRoadSections';

const EditRoadSectionRoadTypeModal = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const checkedRoadSections = useAppSelector(selectedRoadSectionsQuery);
    const checkedRoadSectionsIds = checkedRoadSections.map((s) => s.id);

    const [roadType, setRoadType] = useState('');

    useEffect(() => {
        const roadTypes = checkedRoadSections
            .map((rs) => rs.roadType)
            .filter((n) => n !== undefined)
            .reduce((acc, val) => acc.add(val!), new Set<string>());
        if (roadTypes.size === 1) {
            setRoadType(roadTypes.values().next().value as string);
        } else {
            setRoadType('');
        }
    }, [checkedRoadSections]);

    const onValidate = () => {
        dispatch(
            editRoadSections({
                roadSectionData: {
                    roadType,
                },
                roadSectionIds: checkedRoadSectionsIds,
            }),
        );
        setRoadType('');
    };

    const handleKeyDown = ({ key }: KeyboardEvent) => {
        if (key === 'Enter') {
            onValidate();
        }
    };

    return (
        <GenericModal
            onValidate={onValidate}
            modalType={ReferenceModalTypes.ROAD_SECTION_EDIT_ROAD_TYPE}
            options={{ notDismissableByClickingOnBackground: true }}
        >
            <ContentContainer>
                <ModalTitle>{t('reference.modals.editRoadType')}</ModalTitle>
                <Input
                    onKeyDown={handleKeyDown}
                    value={roadType}
                    type="text"
                    onChange={(e) => setRoadType(e.target.value)}
                    autoFocus
                />
            </ContentContainer>
        </GenericModal>
    );
};

export default EditRoadSectionRoadTypeModal;
